import React from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import Separator from "../../../../../../global components/Icons/Separator";
import BreadCrumb from "../../../../../../global components/BreadCrumbs/BreadCrumbs";
import s from "./InnerPage.module.scss";
import clsx from "clsx";
import useDocumentTitle from "../../../../../../global components/PageTitle";
function ViewDetails() {
  useDocumentTitle("Admin | Users");

  const location = useLocation();
  const pathName = location.pathname;
  const items = [
    {
      title: <Link to="/dashboard/users">Users</Link>,
    },

  ];
  if (pathName.includes("profile")) {
    items.push({
      title: (
        <Link
        onClick={(e)=>e.preventDefault()}

          className={clsx(pathName.includes("profile") && s.active)}
          to="/dashboard/users/profile"
        >
          User details
        </Link>
      ), // Added title text
    });
  } if (pathName.includes("message-details")) {
    items.push({
      title: (
        <Link
        onClick={(e)=>e.preventDefault()}
          className={clsx(pathName.includes("message-details") && s.active)}
          to="/dashboard/users/profile/message-details"
        >
          Message
        </Link>
      ),
    });
  }
  return (
    <div className={s.wrapper}>
      <div className={s.breadCrumb}>
        <BreadCrumb
          items={items}
          separator={<Separator height={11} width={6.67} fill="#9CA3AF" />}
        />
      </div>
      <Outlet />
    </div>
  );
}

export default ViewDetails;
